import { Calendar, MapPin, Clock } from 'lucide-react';
import { EVENT_DETAILS } from '../constants/config';

export default function EventDetails() {
    return (
        <div className="bg-white p-8 shadow-xl">
            <div className="text-center mb-8">
                <h2 className="text-3xl font-bold text-gray-800 mb-2">Join Us in Celebration</h2>
                <p className="text-xl text-gray-600">A Significant Milestone of 60 Years</p>
                <p className="text-sm text-amber-600 mt-2 font-semibold">On a Special Hindu Festival Day</p>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="flex items-start space-x-3 p-4 bg-amber-50 rounded-lg">
                    <Calendar className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" />
                    <div>
                        <p className="font-semibold text-gray-800">Date</p>
                        <p className="text-gray-600">{EVENT_DETAILS.date}</p>
                    </div>
                </div>

                <div className="flex items-start space-x-3 p-4 bg-amber-50 rounded-lg">
                    <Clock className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" />
                    <div>
                        <p className="font-semibold text-gray-800">Time</p>
                        <p className="text-gray-600">{EVENT_DETAILS.time}</p>
                    </div>
                </div>

                <div className="flex items-start space-x-3 p-4 bg-amber-50 rounded-lg md:col-span-2">
                    <MapPin className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" />
                    <div>
                        <p className="font-semibold text-gray-800">Venue</p>
                        <p className="text-gray-600">{EVENT_DETAILS.venue.name}</p>
                        <p className="text-gray-600">{EVENT_DETAILS.venue.address}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}